import React from 'react';
import PropTypes from 'prop-types';
import PermissionFlag from './PermissionFlag';
import ParamsPermissionFlags from './ParamsPermissionFlags';

const PermissionControls = ({
  permission, inputNamePrefix, updateFlag, readOnly = false, canGrantProjectAdmin = true,
}) => {
  // Project Admin is a superset of Manage Users. The interlock is display-only:
  // a disabled checkbox submits nothing, and authorization reads
  // EffectivePermission#manage_project_users, which ORs in write_project.
  const isProjectAdmin = Boolean(permission.write_project);

  return (
    <>
      <td>
        <PermissionFlag
          inputNamePrefix={inputNamePrefix}
          flagName="write_urls"
          flagValue={permission.write_urls}
          updateFlag={updateFlag}
          readOnly={readOnly}
        />
      </td>
      <td>
        <ParamsPermissionFlags
          permission={permission}
          inputNamePrefix={inputNamePrefix}
          updateFlag={updateFlag}
          readOnly={readOnly}
        />
      </td>
      <td>
        <PermissionFlag
          inputNamePrefix={inputNamePrefix}
          flagName="write_presets"
          flagValue={permission.write_presets}
          updateFlag={updateFlag}
          readOnly={readOnly}
        />
      </td>
      <td>
        <PermissionFlag
          inputNamePrefix={inputNamePrefix}
          flagName="write_users"
          flagValue={Boolean(permission.write_users) || isProjectAdmin}
          updateFlag={updateFlag}
          readOnly={readOnly || isProjectAdmin}
        />
      </td>
      <td>
        <PermissionFlag
          inputNamePrefix={inputNamePrefix}
          flagName="write_project"
          flagValue={permission.write_project}
          updateFlag={updateFlag}
          readOnly={readOnly || !canGrantProjectAdmin}
        />
      </td>
    </>
  );
};

PermissionControls.propTypes = {
  permission: PropTypes.object.isRequired,
  inputNamePrefix: PropTypes.string.isRequired,
  updateFlag: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  canGrantProjectAdmin: PropTypes.bool,
};

export default PermissionControls;
